
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { Grid, Container } from '@mui/material';
import Footer from 'src/components/Footer';
import NotificationList from './NotificationsList';
import PageHeaderAnnouncement from './PageHeader';

function NotificationsList() {
  return (
    <>
   
      <Container maxWidth="lg">
      <PageTitleWrapper>
        <PageHeaderAnnouncement />
      </PageTitleWrapper>
      </Container>
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <NotificationList />
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </>
  );
}

export default NotificationsList;
